export const galleryImages = [
  "https://i.ibb.co/Hp44Ts1r/viber-slika-2025-11-27-16-28-40-386.jpg",
  "https://i.ibb.co/0VfWmnhG/viber-slika-2025-11-27-16-28-40-428.jpg",
  "https://i.ibb.co/n83c2BLX/viber-slika-2025-11-27-16-29-10-091.jpg",
  "https://i.ibb.co/svMCtpSJ/viber-slika-2025-11-27-16-29-10-122.jpg",
  "https://i.ibb.co/qY5tnthx/viber-slika-2025-11-27-16-29-22-552.jpg",
  "https://i.ibb.co/Z6YyVH2F/viber-slika-2025-11-27-16-29-22-600.jpg",
  "https://i.ibb.co/SXRmd5Z3/viber-slika-2025-11-27-16-37-11-935.jpg",
  "https://i.ibb.co/wrjHpY8S/viber-slika-2025-11-27-16-37-11-989.jpg",
  "https://i.ibb.co/qYFSLGY6/viber-slika-2025-11-27-16-37-12-028.jpg",
  "https://i.ibb.co/s97wbkZd/viber-slika-2025-11-27-16-37-12-061.jpg",
  "https://i.ibb.co/C522pGCS/viber-slika-2025-11-27-16-37-12-095.jpg",
  "https://i.ibb.co/LhrQnJhX/viber-slika-2025-11-27-16-37-12-132.jpg",
  "https://i.ibb.co/mV4vWhLt/viber-slika-2025-11-27-16-37-12-169.jpg",
  "https://i.ibb.co/SjgQrR9/viber-slika-2025-11-27-16-37-12-205.jpg",
  "https://i.ibb.co/60P9S3PQ/viber-slika-2025-11-27-16-37-12-244.jpg",
  "https://i.ibb.co/rf1NRrvn/viber-slika-2025-11-27-16-37-26-983.jpg",
  "https://i.ibb.co/YBQ3jsZR/viber-slika-2025-11-27-16-37-36-590.jpg",
  "https://i.ibb.co/bj0GPdcT/viber-slika-2025-11-27-16-37-36-632.jpg",
  "https://i.ibb.co/d0sgBCn9/viber-slika-2025-11-27-16-38-38-815.jpg",
  "https://i.ibb.co/H5zq7s9/viber-slika-2025-11-27-16-38-38-861.jpg",
  "https://i.ibb.co/tpGpT9SK/viber-slika-2025-11-27-16-38-38-897.jpg",
  "https://i.ibb.co/Zwzyv78/viber-slika-2025-11-27-16-38-38-935.jpg",
  "https://i.ibb.co/LDwVdwhv/viber-slika-2025-11-27-16-38-38-973.jpg",
  "https://i.ibb.co/sJPQqbDf/viber-slika-2025-11-27-16-38-39-010.jpg",
  "https://i.ibb.co/hJ4MHPCd/viber-slika-2025-11-27-16-38-39-046.jpg",
  "https://i.ibb.co/V0fVrjD8/viber-slika-2025-11-27-16-38-39-089.jpg",
  "https://i.ibb.co/WvvDzmYv/viber-slika-2025-11-27-16-38-39-127.jpg",
  "https://i.ibb.co/QjKWJnRj/viber-slika-2025-11-27-16-38-39-163.jpg",
  "https://i.ibb.co/bgp8Rmdd/viber-slika-2025-11-27-16-38-39-197.jpg",
  "https://i.ibb.co/B5Yjfhj4/viber-slika-2025-11-27-16-38-53-384.jpg",
  "https://i.ibb.co/YFDYwD0k/viber-slika-2025-11-27-16-38-53-421.jpg",
  "https://i.ibb.co/ZpLKJC5T/viber-slika-2025-11-27-16-38-53-445.jpg",
  "https://i.ibb.co/g5tbwFr/viber-slika-2025-11-27-16-38-53-487.jpg",
  "https://i.ibb.co/yc9qVv1h/viber-slika-2025-11-27-16-38-53-523.jpg",
  "https://i.ibb.co/JRPjqvqg/viber-slika-2025-11-27-16-38-53-557.jpg",
  "https://i.ibb.co/h1y68CD3/viber-slika-2025-11-27-16-38-53-598.jpg",
  "https://i.ibb.co/spLdsW2j/viber-slika-2025-11-27-16-38-53-636.jpg",
  "https://i.ibb.co/TGP5hBH/viber-slika-2025-11-27-16-46-03-085.jpg",
  "https://i.ibb.co/6RnWv800/viber-slika-2025-11-27-16-46-03-207.jpg",
  "https://i.ibb.co/4R7RgySg/viber-slika-2025-11-27-16-46-03-237.jpg",
  "https://i.ibb.co/8g4gzHsj/viber-slika-2025-11-27-16-46-03-268.jpg",
  "https://i.ibb.co/zwVVjQ2/viber-slika-2025-11-27-16-46-03-315.jpg",
  "https://i.ibb.co/wFkncvZ0/viber-slika-2025-11-27-16-46-03-422.jpg"
];

export const guaranteeLogo = "https://i.ibb.co/Y4k6RS9H/logo.jpg";
